"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggRefAndQuoteNumberOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var AggRefAndQuoteNumberOutputWidget = /** @class */ (function (_super) {
    __extends(AggRefAndQuoteNumberOutputWidget, _super);
    function AggRefAndQuoteNumberOutputWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AggRefAndQuoteNumberOutputWidget.prototype.render = function () {
        var quoteRefNum = this.props.quoteRef;
        var source = this.props.source;
        var imgSrc;
        switch (source) {
            case "elx":
                imgSrc = "/img/electrix-icon.svg";
                break;
            case "ctm":
                imgSrc = "/img/compare-the-market-icon.png";
                break;
            case "ctmhome":
                imgSrc = "/img/compare-the-market-icon.png";
                break;
            case "cnf":
            case "cnfhome":
                imgSrc = "/img/confused-icon.png";
                break;
            case "gc":
                imgSrc = "/img/go-compare-icon.png";
                break;
            case "gchome":
                imgSrc = "/img/annual/home/gocompare-home.svg";
                break;
            case "msm":
                imgSrc = "/img/money-supermarket-icon.png";
                break;
            case "msmhome":
                imgSrc = "/img/money-supermarket-icon.png";
                break;
            default:
                break;
        }
        if (source && imgSrc === undefined) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "agg-name-quote-ref-output ".concat(source ? "justify-content-between" : "justify-content-end"), children: [source &&
                    (0, jsx_runtime_1.jsxs)("div", { className: "aggregator-reference-output", children: [(0, jsx_runtime_1.jsx)("div", { className: "aggregator-label", children: "This quote is via" }), (0, jsx_runtime_1.jsx)("img", { className: "aggregator-img ".concat(source || ''), src: imgSrc, alt: "Aggregator source icon" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "quote-ref-output", children: ["ref: ", (0, jsx_runtime_1.jsx)("span", { className: "ref-num", children: quoteRefNum })] })] }));
    };
    return AggRefAndQuoteNumberOutputWidget;
}(React.Component));
exports.AggRefAndQuoteNumberOutputWidget = AggRefAndQuoteNumberOutputWidget;
//# sourceMappingURL=AggRefAndQuoteNumberOutputWidget.js.map